<!-- Section A: Firm House Views -->
<app-house-views-readonly
  [views]="firmViews"
  [enabledMap]="firmEnabled"
  label="Firm House Views"
  sourceKey="firm"
  (masterToggleChange)="onFirmMasterToggle($event)"
  (viewToggleChange)="onFirmViewToggle($event)">
</app-house-views-readonly>

<!-- Section B: My Core Views -->
<app-house-views-readonly
  [views]="userViews"
  [enabledMap]="userEnabled"
  label="My Core Views"
  sourceKey="user"
  (masterToggleChange)="onUserMasterToggle($event)"
  (viewToggleChange)="onUserViewToggle($event)">
</app-house-views-readonly>

<!-- Section C: Portfolio Views (Overrides) -->
<div class="portfolio-views-card">
  <div class="card-header d-flex align-items-center">
    <mat-icon class="me-2">tune</mat-icon>
    <strong>Portfolio Views (Overrides)</strong>
  </div>
  <div class="card-body">
    <app-views-setter
      [portfolio]="portfolio"
      [sectors]="constraintLists?.sectors || []"
      [assets]="constraintLists?.assets || []"
      [countries]="constraintLists?.countries || []"
      [benchmarks]="constraintLists?.benchmarks || []"
      [views]="optimizationData?.views || []">
    </app-views-setter>
  </div>
</div>

<!-- Section D: Effective Views -->
<app-effective-views
  [payload]="effectivePayload"
  [loading]="payloadLoading"
  [error]="payloadError"
  [resetEnabled]="resetCompleted"
  [resetLoading]="resetLoading"
  [optimizing]="optimizing"
  (generate)="generatePayload()"
  (optimize)="optimize.emit()"
  (reset)="onResetViews()">
</app-effective-views>
